// /scramble/new — mint a fresh scramble round and hand back its shareable link.
//
// Visiting this route generates a random unguessable slug, seeds a default round
// (Team 1/2/3 + par-72), and redirects to /scramble/<slug>. Unlisted: nothing in
// the app links here — you hit it directly when you want a new link to share.
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { newSlug, createRound } from "./scrambleDb";
import "./scramble.css";

export default function ScrambleNew() {
  const navigate = useNavigate();
  const started = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    // StrictMode double-invokes effects in dev; guard so we only create once.
    if (started.current) return;
    started.current = true;
    const slug = newSlug();
    createRound(slug)
      .then(() => navigate(`/scramble/${slug}`, { replace: true }))
      .catch(() => setFailed(true));
  }, [navigate]);

  return (
    <div className="scramble-root">
      <div className="center-state">
        {failed ? (
          <>
            <h2>Couldn’t start a round</h2>
            <p>Something went wrong creating the scorecard. Refresh to try again.</p>
          </>
        ) : (
          <p>Creating your round…</p>
        )}
      </div>
    </div>
  );
}
